<template>
  <div class="page-products__products">
    <v-card class="pa-2" rounded="lg">
      <Resource
        :document="document"
        :filter-fields="null"
        :filter-data="filterData"
        :filter-callback="setFilterData"
        :searchable="searchableField"
        :columns="columns"
        :actionItems="items"
        :update-router-callback="getUpdateRouterData"
        :callback-action="getAction"
      />
      <div class="d-flex justify-space-between mt-3">
        <limit-page :callback="setLimit" />
        <pagination
          :length="lengthPage"
          :visible="0"
          v-if="!$parent.isLoading && document"
          :page.sync="page"
        ></pagination>
      </div>
    </v-card>
    <v-dialog persistent v-model="showModalDelete" width="500" style="transform-origin: center top">
      <v-card relative>
        <!-- Title -->
        <v-card-title class="headline"> {{ 'Delete' }} {{ ids.length }} offer?. </v-card-title>
        <div class="close-icon" @click="showModalDelete = false">
          <v-icon>fas fa-times</v-icon>
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-card-text class="">
          Are you sure you want to delete {{ ids.length }} offers. This action cannot be reversed.
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" @click="showModalDelete = false"> Cancel </v-btn>
          <v-btn :loading="isLoadingButton" color="error" @click="onSubmitDelete"> Delete </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Resource from '@/components/Resources';
import resourceListMixin from '@/mixins/resource-list';
import { offerApi } from '@/apis/offers';

export default {
  components: { Resource },
  mixins: [resourceListMixin],
  data() {
    return {
      showModalDelete: false,
      resourceType: 'offer',
      isLoadingButton: false,
      currentTab: 0,
      ids: [],

      // page: 1,
      items: [
        { title: 'Active offer', action: 'activate' },
        { title: 'Deactivate offer ', action: 'deactivate' },
        { title: 'Delete ', action: 'remove-bulk' },
      ],
      tabs: [
        { name: 'All offers', key: 'bundle' },
        // { name: 'Active offer', key: 'quantity' },
        // { name: 'Pre-purchase offers', key: 'prePurchase' },
        // { name: 'In-cart offers', key: 'inCart' },
        // { name: 'Post purchse', key: 'postPurchase' },
      ],
      testVuex: null,
      offerType: 'bundle',
      columns: {
        Selectable: {
          blankLabel: true,
          kind: 'selectable',
          width: 1,
        },
        // Priority: {
        //   field: 'priority',
        //   kind: 'priority-custom',
        // },
        'Offer name': {
          field: 'offerName',
          kind: 'view',
        },
        'Product/Collection': {
          field: 'custom',
          kind: 'showOffer',
        },
        // Type: {
        //   kind: 'text',
        //   field: 'offerType',
        // },
        Status: {
          kind: 'status',
          field: 'activated',
        },
      },
      updateRouteName: 'website.apps.bundle.update',
      searchableField: 'title_search',
      sortable: [],
    };
  },
  created() {},
  methods: {
    getIds(ids) {
      this.$parent.ids = ids;
    },
    async onSubmitDelete() {
      try {
        this.isLoadingButton = true;
        await offerApi.remove(`?ids=${this.ids.join(',')}`);
        this.isLoading = true;
        this.showModalDelete = false;

        await this.getResources();
        this.isLoading = false;
      } catch (error) {
        //empty
      }
      this.showModalDelete = false;
      this.isLoadingButton = false;
    },
    async getAction(action, ids) {
      this.ids = ids;
      this.action = action.action;
      if (action.action === 'bulk-edit') {
        this.$router.push({
          name: 'website.products.bulkEdit',
          query: {
            ids: ids.join(','),
          },
        });
      }
      if (action.action === 'deactivate' || action.action === 'activate') {
        try {
          await offerApi.changeActive(action.action, ids);
          this.isLoading = true;

          await this.getResources();
          this.isLoading = false;
        } catch (error) {
          console.log(error);
          //empty
        }
      }

      if (action.action === 'remove-bulk') {
        this.showModalDelete = true;
      }
    },
  },
};
</script>
<style lang="scss">
.page-products__products {
  background: white;
}
</style>
